module.exports = __webpack_public_path__ + "assets/img/22_1318_big.cf663d8a.jpg";